(function (angular) {
  "use strict";

  angular.module("app").directive("package", packageDirective);

  packageDirective.$inject = [
    "MemberPackagesApi",
    "MemberPackages",
    "thisSiteSettings",
  ];

  function packageDirective(
    MemberPackagesApi,
    MemberPackages,
    thisSiteSettings,
  ) {
    function link($scope) {
      $scope.bought = false;
      $scope.buyPackage = buyPackage;
      $scope.currencySymbol = thisSiteSettings.currency_symbol;
      $scope.thisSiteSettings = thisSiteSettings;

      /**
       * Buy a package modal gets opened and the flow starts.
       *
       * @return {void}
       */
      function buyPackage() {
        if (!$scope.bought) {
          MemberPackages.buy($scope.data.id).result.then(function (success) {
            if (success) {
              $scope.bought = true;
            } else {
            }
          });
        }
      }
    }

    return {
      restrict: "E",
      templateUrl: "directives/package.html",
      transclude: true,
      link: link,
      scope: {
        data: "=",
      },
    };
  }
})(angular);
